import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-389adc7f"), n = n(), _popScopeId(), n);
const _hoisted_1 = { id: "server-overlay-container" };
const _hoisted_2 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.servers, (server) => {
            return (_openBlock(), _createElementBlock("div", {
                key: server.id
            }, [
                _createElementVNode("div", {
                    class: "server-button",
                    onClick: ($event) => (_ctx.onClickServer(server.id))
                }, _toDisplayString(server.text), 9, _hoisted_2)
            ]));
        }), 128))
    ]));
}
